{
  "paragraph-1": "Informationen i den här ansökan används för att säkerställa att vi matchar dina prioriterade kompetensutvecklingsbehov och verksamhetsmål med relevanta lärandeprogram samt möjlighet att bjuda in till bjuda in till komplementerande lärandeteam.",
  "paragraph-2": "Ju mer utförligt du svarar desto bättre kommer vi kunna matcha dig till program och lärandeteam.",
  "Objectives": "Målsättning",
  "Objectives_details": "vänligen ange två personliga och två professionella mål du vill uppnå genom att genomföra programmet.",
  "Contribution": "Medverkan",
  "Contribution_details": "vilka erfarenheter och kompetenser har du inom området som kan bidra till lärandeupplevelsen för andra deltagare?",
  "Challenges": "Utmaningar",
  "Challenges_details": "vänligen beskriv några av de huvudsakliga utmaningar som du personligen ställs inför i din versamhetsmiljö, om det går beskriv även ett initiativ du är inblandad i som du kommer arbeta med under programmets gång.",
  "Personal Information": "Personlig information",
  "personal-info-p1": "Vi värderar mångfald och inklusion såväl som att tillhandahålla lika möjlighet för personlig och professionell utveckling.",
  "personal-info-p2": "För att försäkra att vi som organisation lever upp till detta så skulle det vara oss till hjälp ifall du kan bidra med informationen nedan.",
  "Gender identification": "Kön",
  "Select an option": "Välj ett alternativ",
  "Male": "Man",
  "Female": "Kvinna",
  "Other": "Annat",
  "Prefer not to state": "Föredrar att inte säga",
  "Comfort level in English": "Engelskakunskaper",
  "(Basic)": "(Basic)",
  "(Native)": "(Native)",
  "First language": "Modersmål",
  "Geographic location": "Plats",
  "Sweden": "Sverige",
  "Denmark": "Danmark",
  "Norway": "Norge",
  "Finland": "Finland",
  "Baltics": "Baltikum",
  "Other Europe": "Övriga Europa",
  "Asia": "Asien",
  "Americas": "America",
  "Highest educational degree": "Utbildningsnivå",
  "Current position": "Nuvarande befattning",
  "Team member": "Teammedlem",
  "Team leader": "Teamledare",
  "Manager": "Mellanchef",
  "Executive": "Högre chef",
  "Work experience in current area": "Yrkeserfarenhet inom nuvarande område",
  "years": "år",
  "Management experience": "Erfarenhet inom ledarskap",
  "Submit application": "Skicka in ansökan",
  "Product": "Produkt",
  "User": "Namn",
  "Note": "Svar",
  "Applications": "Ansökningar",
  "There are no pending applications": "Det finns inga ohanterade ansökningar.",
  "Reject": "Neka",
  "Approve": "Godkänn",
  "Location": "Plats",
  "Method": "Metod",
  "Are you sure that you want to reject this application?": "Är du säker på att du vill neka ansökan?",
  "Are you sure that you want to approve this application?": "Är du säker på att du vill godkänna ansökan?",
  "Runs between {{validFrom}} and {{validTo}}": "Giltig mellan {{validFrom}} och {{validTo}}",
  "Runs from {{validFrom}}": "Giltig från {{validFrom}}",
  "Runs until {{validTo}}": "Giltig till {{validTo}}",
  "Order Id": "Order-ID",
  "Your organization has no remaining licenses for this product.": "Din organisation har inte några licenser kvar för den här produkten."
}
